import { Field } from '@k2/common/k2-forms-state/types';

export function textareaFormatter(field: Field): string {
  return field.control.value;
}
